<ng-container *ngrxLet="product$ as product">
  <ng-container *ngIf="product">
    <button mat-flat-button class="close-btn" (click)="dialogRef.close()">
      <mat-icon>close</mat-icon>
    </button>
    <div class="image-container">
      <ng-container *ngIf="(product.images?.length ?? 0) > 1">
        <button mat-flat-button class="prev-btn" (click)="prevImage()">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <button mat-flat-button class="next-btn" (click)="nextImage()">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </ng-container>
      <img
        *ngIf="activeImage; else noProductPicture"
        class="img"
        [src]="imageBaseUrl + '/' + activeImage.largeUrl"
        [attr.alt]="activeImage.alt"
      />
      <ng-template #noProductPicture>
        <div>{{ "SEARCH.RESULT_CARD.NO_IMAGE" | translate }}</div>
      </ng-template>
      <app-drs-fee-logo
        *ngIf="product.additionalDepositFee"
        class="drs_logo"
        [containerWidth]="105"
        [containerHeight]="95"
        [logoWidth]="150"
      ></app-drs-fee-logo>
    </div>

    <div class="details">
      <div class="header">
        <h2>{{ data.product.label }}</h2>
        <div class="top-right-corner">
          <div class="d-flex align-items-baseline prices">
            <div class="me-2">Nettó:</div>
            <span class="price small">{{
              product.minPrice?.netPrice | number: "0.0-0"
            }}</span>
            <span>Ft-tól</span>
            <span class="price small price-divider">-</span>
            <span class="price small">{{
              product.maxPrice?.netPrice | number: "0.0-0"
            }}</span>
            <span>Ft-ig</span>
          </div>
          <div class="d-flex align-items-baseline prices">
            <div class="me-2">Bruttó:</div>
            <span class="price">{{
              product.minPrice?.grossPrice | number: "0.0-0"
            }}</span>
            <span>Ft-tól</span>
            <span class="price price-divider">-</span>
            <span class="price">{{
              product.maxPrice?.grossPrice | number: "0.0-0"
            }}</span>
            <span>Ft-ig</span>
          </div>
        </div>
      </div>
      <p class="description">
        {{ product.shortDescription }}
      </p>
      <div class="small-prices">
        <div class="d-flex align-items-baseline justify-content-center">
          <div class="price-label me-2">Nettó:</div>
          <span class="price small">{{
            product.minPrice?.netPrice | number: "0.0-0"
          }}</span>
          <span>Ft-tól</span>
          <span class="price small price-divider">-</span>
          <span class="price small">{{
            product.maxPrice?.netPrice | number: "0.0-0"
          }}</span>
          <span>Ft-ig</span>
        </div>
        <div class="d-flex align-items-baseline">
          <div class="price-label me-2">Bruttó:</div>
          <span class="price">{{
            product.minPrice?.grossPrice | number: "0.0-0"
          }}</span>
          <span>Ft-tól</span>
          <span class="price price-divider">-</span>
          <span class="price">{{
            product.maxPrice?.grossPrice | number: "0.0-0"
          }}</span>
          <span>Ft-ig</span>
        </div>
      </div>
      <ng-container *ngrxLet="logoImages$ as logoImages">
        <div class="merchants" *ngIf="logoImages?.length">
          <p>Easyloton beszállítja:</p>
          <app-image-swiper
            [images]="logoImages!"
            [autoplay]="false"
            [noTopPadding]="true"
          ></app-image-swiper>
        </div>
      </ng-container>
      <div class="footer">
        <a
          mat-flat-button
          [routerLink]="
            '/buying/search/product-details/' + data.product.packagingUnitId
          "
          (click)="dialogRef.close()"
        >
          <div class="details-btn-content">
            További részletek
            <mat-icon fontSet="material-icons-outlined">
              keyboard_double_arrow_right
            </mat-icon>
          </div>
        </a>
      </div>
    </div>
  </ng-container>
</ng-container>
